import React from "react";
import ScreenSelector from "@icarius-common/screenSelector";
import paths from "@icarius-router/paths";
import {
  ConceptsIcon,
  CalculationFunctionIcon,
  ConceptGroupsIcon,
  AccumIcon,
  PayrollTypeIcon,
  CalculationReferenceIcon,
  ConceptStructureIcon,
  ConceptsSetIcon,
  SpecialProcessDefinitionIcon,
} from "@icarius-icons/";
import { getLocalizedString } from "@icarius-localization/strings";

const ConceptsFormulasFunctions = ({ history }) => {

  const data = [
    {
      name: getLocalizedString("conceptsAndFormulas"),
      icon: <ConceptsIcon />,
      path: paths.conceptsAndFormulas,
    },
    {
      name: getLocalizedString("calculationsFunctions"),
      icon: <CalculationFunctionIcon />,
      path: paths.calculationsFunctions,
    },
    {
      name: getLocalizedString("conceptGroups"),
      icon: <ConceptGroupsIcon />,
      path: paths.conceptGroups,
    },
    {
      name: getLocalizedString("filterAcumuladores"),
      icon: <AccumIcon />,
      path: paths.accumulatorSettings,
    },
    {
      name: getLocalizedString("payrollTypesSettings"),
      icon: <PayrollTypeIcon />,
      path: paths.payrollTypes,
    },
    {
      name: getLocalizedString("calculationReferences"),
      icon: <CalculationReferenceIcon />,
      path: paths.calculationReferences,
    },
    {
      name: getLocalizedString("incomeStructuresOfConcepts"),
      icon: <ConceptStructureIcon />,
      path: paths.conceptStructure,
    },
    {
      name: getLocalizedString("conceptsSetSettingsTitle"),
      icon: <ConceptsSetIcon />,
      path: paths.conceptSet
    },
    {
      name: getLocalizedString("specialProcessDefinition"),
      icon: <SpecialProcessDefinitionIcon />,
      path: paths.specialProcessDefinition,
      onClick: () => {
        history.push({
          pathname: paths.specialProcessDefinition,
          state: {
            from: paths.conceptsAndFormulasScreenSelector,
          },
        });
      }
    },
  ];

  return (
    <ScreenSelector
      title={getLocalizedString("conceptsFormulasFunctions")}
      data={data}
    />
  );
}

export default ConceptsFormulasFunctions;
